import { LocalStorageService } from "@/Services/LocalStorageService";

import { LocalStorageNamespace } from "../Models/Localstorage/LocalStorageNamespace";

import { isApp } from "@/Utils/Ionic";
import { unixUTC } from "@/Utils/Date";

class UpdatePreviewActionHandler {
  constructor(
    private readonly previewLocalStotage: LocalStorageService = new LocalStorageService(
      LocalStorageNamespace.PREVIEW
    )
  ) {}

  public handle() {
    if (isApp()) {
      const date = unixUTC();

      this.previewLocalStotage.set("date", date);

      return date;
    }

    return 0;
  }
}

export default UpdatePreviewActionHandler;
